<style scoped lang="scss">
	._formList /deep/ .el-input__inner {
		-webkit-appearance: none;
		background-color: #fff;
		background-image: none;
		border-radius: 4px;
		border: 1px solid #dcdfe6;
		-webkit-box-sizing: border-box;
		box-sizing: border-box;
		color: #606266;
		display: inline-block;
		font-size: inherit;
		height: 28px;
		line-height: 40px;
		outline: none;
		padding: 0 15px;
		-webkit-transition: border-color .2s cubic-bezier(.645,.045,.355,1);
		transition: border-color .2s cubic-bezier(.645,.045,.355,1);
		width: 545px;
	}
</style>

<template>

	<div style="display: inline;">
		<yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt"  getUrl="/web/material/warehouse/page"
			getKey="rows" :columns="columns">
			<!-- 左侧按钮插槽 -->
			<template #buttonsL="scope">
				<el-button type="primary" size="mini" @click="yt.showEditDialog('xinzeng',null,'w2')">
					{{$t('xinzeng')}}
				</el-button>
			</template>
			<!-- 操作插槽 -->
			<template #caozuo="scope">
				<el-row :gutter="10">
					<el-col :span="0.1">
						<el-button type="text" @click="yt.showEditDialog('bianji', scope.row, 'w2', beforeEdit)">{{$t('bianji')}}
						</el-button>
					</el-col>
					<el-col :span="0.1">
						<el-button type="text" :loading="yt.editObj.loading" class="font-color-danger"
							@click="yt.remove(scope.row,'/web/material/warehouse/delete')">{{$t('shanchu')}}
						</el-button>
					</el-col>
				</el-row>
			</template>
		</yi_curd_table>

		<!-- 新增/编辑弹框 -->
		<el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog"
			:width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
			<!-- 新增表单 -->
			<template v-if="yt.editObj.action == 'xinzeng'">
				<el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
					<el-form-item :label="$t('cangku/kuqu/kuwei')" required>
						<yi_data_select class="_formList" :key="'1'" :showAllLevels="true" :clearable="false" :multiple="false" :max="1" :checkStrictly="true" :warehouseLevel="2" :type="'warehouse'"
										:idsPathParent.sync="yt.editObj.idsPathParent" :ids.sync="yt.editObj.warehouseId">
						</yi_data_select>
					</el-form-item>
				</el-form>
				<span slot="footer" class="dialog-footer">
					<el-button size="mini" @click="yt.isShowEditDialog = false">{{$t('quxiao')}}</el-button>
					<el-button size="mini" :loading="yt.editObj.loading" @click="yt.req('POST','/web/material/warehouse/create',beforeAdd)"
						type="primary">
						{{$t('baocun')}}
					</el-button>
				</span>
			</template>
			<template v-if="yt.editObj.action == 'bianji'">
				<el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
					<el-form-item :label="$t('cangku/kuqu/kuwei')" required>
						<yi_data_select class="_formList" :key="'1'" :showAllLevels="true" :clearable="false" :multiple="false" :max="1" :checkStrictly="true" :warehouseLevel="2" :type="'warehouse'"
										:idsPathParent.sync="yt.editObj.idsPathParent" :ids.sync="yt.editObj.warehouseId">
						</yi_data_select>
					</el-form-item>
				</el-form>
				<span slot="footer" class="dialog-footer">
					<el-button size="mini" @click="yt.isShowEditDialog = false">{{$t('quxiao')}}</el-button>
					<el-button size="mini" :loading="yt.editObj.loading" @click="yt.req('POST','/web/material/warehouse/update', beforeAdd)" type="primary">
						{{$t('baocun')}}
					</el-button>
				</span>
			</template>
		</el-dialog>
	</div>

</template>

<script type="text/javascript">
	export default {
		name: 'web_base_matter_matter_warehouse',
		data() {
			return {

				columns: [{
					label: 'cangkubianma',
					prop: 'warehouse.code',
				}, {
					label: 'cangkumingcheng',
					prop: 'warehouse.name',
				}, {
					label: 'kuqubianma',
					prop: 'warehouseArea.code',
				}, {
					label: 'kuqumingcheng',
					prop: 'warehouseArea.name',
				}, {
					label: 'kuweibianma',
					prop: 'warehouseLocation.code',
				}, {
					label: 'kuweimingcheng',
					prop: 'warehouseLocation.name',
				}, {
					label: 'chuangjianshijian',
					prop: 'createTime',
					type: 'time',
				},  {
					label: 'chuangjianren',
					prop: 'createByObject.nickname',
				}, {
					label: 'caozuo',
					type: 'slot',
					fixed: 'right',
					width: 120
				}]
			}
		},
		created() {
			setTimeout(() => {
				this.yt.conditions = {
					materialId: this.$attrs.material.id,
					pageNum: 1,
					pageSize: 100
				}
				this.yt.get(1);
				this.yt.isShowPagination = false;
			}, 300)

		},
		methods: {
			beforeAdd(params, url) {
				params.materialId = this.$attrs.material.id;
				params.warehouseId = params.idsPathParent && params.idsPathParent[0]?params.idsPathParent[0]:null
				params.warehouseAreaId = params.idsPathParent && params.idsPathParent[1]?params.idsPathParent[1]:null
				params.warehouseLocationId = params.idsPathParent && params.idsPathParent[2]?params.idsPathParent[2]:null
				params.warehouseId = parseInt((params.warehouseId + '').substring(1));
				params.warehouseAreaId = parseInt((params.warehouseAreaId + '').substring(1));
				params.warehouseLocationId = parseInt((params.warehouseLocationId + '').substring(1));
				return params
			},
			beforeEdit(row, url) {
				let warehouseId = row.warehouseId?parseInt( '1' + row.warehouseId):null;
				let warehouseAreaId = row.warehouseAreaId?parseInt( '2' + row.warehouseAreaId):null;
				let warehouseLocationId = row.warehouseLocationId?parseInt( '3' + row.warehouseLocationId):null;
				if (warehouseLocationId){
					row.warehouseId = warehouseLocationId;
				} else if (warehouseAreaId){
					row.warehouseId = warehouseAreaId;
				} else {
					row.warehouseId = warehouseId;
				}
				return row;
			},

		}
	}
</script>

<style scoped lang="scss">
	
</style>
